import { createFileRoute } from '@tanstack/react-router'
import { CalendarExceptionEditor } from './-CalendarExceptionEditor'

export const Route = createFileRoute('/settings/calendar/$id')({
  component: EditCalendarExceptionPage,
})

function EditCalendarExceptionPage() {
  const { id } = Route.useParams()
  return <CalendarExceptionEditor id={id} />
}
